import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_NODES_SW_API_URL, NETSTAT_SWITCH_URL } from '../Optics/OpticApiConfig';
import { loadingNumberNode } from '../Optics/LoadingData/LoadingDataTerritory';
import Select from 'react-select';
import DescriptionSwitchDialog from './DescriptionSwitchDialog';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const Nodes = (user) => 
  {

  const [selectedNode, setSelectedNode] = useState('');
  const [resultPon, setPon] = useState([]);
  const [resultKp, setKp] = useState([]);
  const [resultEther, setEther] = useState([]);
  const [resultInfo, setInfo] = useState([]);
  const token = localStorage.getItem('token');
  const [node, setNode] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const [openModalAmplifier, setOpenModalAmplifier] = useState(false);
  const [itemData, setItemData] = useState([]);
  

   useEffect(() => {
        loadingNumberNode(setNode); 
      }, []); 
  

   const handleButtonClick = async () => {
    if (!selectedNode) {
      return;
    }
  
    try {
      const [nodeResponse] = await Promise.all([
        axios.get(GET_NODES_SW_API_URL, {
          headers: { Authorization: `Bearer ${token}` },
          params: { node: selectedNode }
        })
      ]);
  
      const data = nodeResponse.data;
  
      setPon(data.pon);
      setKp(data.kp);
      setEther(data.ether);
      setInfo(data.info);
  
      setIsVisible(true);
    } catch (error) {
      console.error('Error fetching data', error);
    }
  };

   const handleClick = (item) => {
    setItemData(item);
    setOpenModalAmplifier(true);
   };


  return (
    <> 
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
    <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px" }}>Узел</label>
      <Select
            className="selectSearchDrawer"
            options={node.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="номер"
            onChange={(selectedOption) => setSelectedNode(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={handleButtonClick} 
          >
            Загрузить
          </button>  
      </div>
      <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
    </div>
   
    {isVisible && (
      <div style={{ display: 'flex', marginTop: '5px' , width: '1200px'}}>
                    {/* ETHER */}
                    <div className='dialog-section-node' >
                      <div style={{ display: "flex", alignItems: "center" }}>
                      <img src='./3k.png' width='30' height='30' style={{ marginRight: "5px" }} alt="PON Box" />
                      <h3 style={{ fontWeight: 'bold', fontSize: '16px', color: "#afafaf"}}>Оборудование ({resultEther.length} шт.)</h3>
                      </div>
                      <hr className="horizontalLineNodes" style={{ marginBottom: "5px" }} />
                      {resultEther.length > 0 ? resultEther.map((coord, idx) => (
                      
                        <div key={idx} className='custom-box-node' style={{ marginBottom: '3px' }} onClick={() => handleClick(coord)}>
                            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}> {coord.model}</span><br />
                            <span style={{ fontWeight: 'bold', fontSize: '12px' }}> Портов:</span> <span style={{ fontSize: '12px' }}>  {coord.ports}</span><br />

                            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Ip:</span> <span style={{ fontSize: '12px', color:'#1f4db1', fontWeight: 'bold' }}>
                            {coord.ip}
                          </span><br />
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Мак:</span> <span style={{ fontSize: '12px' }}>{coord.mac}</span><br />
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Дата установки:</span> <span style={{ fontSize: '12px' }}>  {coord.added}</span><br />
                        </div>
                      )) : <p>Нет данных для отображения</p>}     
                   </div>

                  {/* PON */}
                 <div className='dialog-section-node'>
                 <div style={{ display: "flex", alignItems: "center" }} >
                      <img src='./olt.png' width='30' height='30' style={{ marginRight: "5px" }} alt="PON Box" />
                      <h3 style={{ fontWeight: 'bold', fontSize: '16px', color: "#afafaf" }}> PON ({resultPon.length} шт.)</h3>
                      </div>
                    
                      <hr className="horizontalLineNodes" style={{ marginBottom: "5px" }} />
                      {resultPon.length > 0 ? resultPon.map((coord, idx) => (
                      
                        <div key={idx} className='custom-box-node' style={{ marginBottom: '3px' }} onClick={() => handleClick(coord)}>
                            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}> {coord.model}</span>
                          <br />

                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Ip:</span> <span style={{ fontSize: '12px' }}>
                               <a href={`${NETSTAT_SWITCH_URL}?ip=${coord.ip}`} target="_blank" style={{ fontWeight: 'bold', color:"#005fb8" }} onClick={(event) => event.stopPropagation()} >{coord.ip}</a>
                          </span><br/>
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Мак:</span> <span style={{ fontSize: '12px' }}>{coord.mac}</span><br />
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Дата установки:</span> <span style={{ fontSize: '12px' }}>  {coord.added}</span><br />                        
                        </div>
                      )) : <p>Нет данных для отображения</p>}        
                </div>

                {/* KP */}
                <div className='dialog-section-node'>
                <div style={{ display: "flex", alignItems: "center" }}>
                      <img src='./kp.png' width='25' height='25' style={{ marginRight: "5px" }} alt="PON Box" />
                      <h3 style={{ fontWeight: 'bold', fontSize: '16px', color: "#afafaf" }}>Датчик ({resultKp.length} шт.)</h3>
                      </div>
                    
                      <hr className="horizontalLineNodes" style={{ marginBottom: "5px" }} />
                      {resultKp.length > 0 ? resultKp.map((coord, idx) => (
                      
                        <div key={idx} className='custom-box-node' style={{ marginBottom: '3px' }} onClick={() => handleClick(coord)}>
                            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}> {coord.model}</span>
                          <br />

                            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Ip:</span> <span style={{ fontSize: '12px', color:'#1f4db1', fontWeight: 'bold' }}>
                            {coord.ip}
                          </span><br />
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Мак:</span> <span style={{ fontSize: '12px' }}>{coord.mac}</span><br />
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Дата установки:</span> <span style={{ fontSize: '12px' }}>  {coord.added}</span><br /> 
                        </div>
                      )) : <p>Нет данных для отображения</p>}          
                </div>

                {/* INFO */}
                <div >
                        <div  className='custom-box-info' style={{ marginBottom: '3px' }}>
                            <span style={{ fontWeight: 'bold' }}>Дирекция:</span> <span> {resultInfo.directory}</span>
                          <br />

                            <span style={{ fontWeight: 'bold' }}>Город:</span> <span>
                            {resultInfo.city}
                          </span><br />

                          <span style={{ fontWeight: 'bold'}}>Округ:</span> <span>
                            {resultInfo.canton}
                          </span><br />
                          <span style={{ fontWeight: 'bold'}}>Регион:</span> <span>
                            {resultInfo.region}
                          </span><br />
                          <span style={{ fontWeight: 'bold' }}>Ветка:</span> <span >
                            {resultInfo.area}
                          </span><br />
                          <hr className="horizontalLineNodes" style={{ marginBottom: "5px" }} />
                          <span style={{ fontWeight: 'bold'}}>РМ:</span> <span >
                            {resultInfo.regionManager}
                          </span><br />
                          <span style={{ fontWeight: 'bold'}}>РИ:</span> <span >
                            {resultInfo.regionEngineer}
                          </span><br />
                          <span style={{ fontWeight: 'bold'}}>СМ:</span> <span>
                            {resultInfo.regionSenior}
                          </span><br /> 
                        </div>  
                </div>   
      </div>
    )}

      <DescriptionSwitchDialog
        open={openModalAmplifier}
        onClose={() => setOpenModalAmplifier(false)}
        item={itemData}
      /> 
  </>
  );
};

export default Nodes;
